import styled from '@xstyled/styled-components';
import Speaker from '~/assets/icons/hotspot-symbol-speaker.svg';

export const SpeakerIcon = styled(Speaker)`
  max-width: 33px;
  max-height: 33px;
  color: black;
  width: 33px;
  height: 33px;
`;
